/* Petal Maison product section behaviour. Extracted from sections/tm-product.liquid. */
(function() {
  function initSection(sectionId) {
    const etaEl = document.getElementById('tm-eta-' + sectionId);
    if (etaEl) {
      const minD = parseInt(etaEl.dataset.min || '4', 10);
      const maxD = parseInt(etaEl.dataset.max || '8', 10);
      const prefix = etaEl.dataset.prefix || 'Arrives between';
      const join = etaEl.dataset.join || 'and';
      const ordinal = n => { const s = ['th','st','nd','rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); };
      const fmtDate = d => d.toLocaleDateString('en-US', { month: 'long' }) + ' ' + ordinal(d.getDate());
      const etaStart = new Date(); etaStart.setDate(etaStart.getDate() + minD);
      const etaEnd = new Date(); etaEnd.setDate(etaEnd.getDate() + maxD);
      etaEl.innerHTML = prefix + ' <strong>' + fmtDate(etaStart) + '</strong> ' + join + ' <strong>' + fmtDate(etaEnd) + '</strong>';
    }
    const dataEl = document.getElementById('tm-product-data-' + sectionId);
    if (!dataEl) return;
    const productData = JSON.parse(dataEl.textContent);
    const form = document.getElementById('tm-form-' + sectionId);
    const variantIdInput = document.getElementById('tm-variant-id-' + sectionId);
    const priceContainer = document.getElementById('tm-price-' + sectionId);
    const atcButton = document.getElementById('tm-atc-' + sectionId);
    if (!form || !atcButton) return;
    const atcText = atcButton.querySelector('.tm-product__atc-text');
    const L = atcButton.dataset;
    const stockIndicator = document.getElementById('tm-stock-' + sectionId);
    class TMCarousel {
      constructor({ viewport, track, counterEl }) {
        this.viewport = viewport; this.track = track; this.counterEl = counterEl;
        this.originalSlides = Array.from(track.children); this.realCount = this.originalSlides.length;
        this.currentIndex = 0; this.translate = 0; this.isDragging = false;
        this.startX = 0; this.startY = 0; this.dragX = 0; this.lockedAxis = null; this.activePointerId = null;
        if (this.realCount > 1) this.setupClones();
        this.slides = Array.from(track.children);
        if (this.realCount > 1) this.currentIndex = 1;
        this.bindEvents(); this.update(false);
      }
      setupClones() {
        const firstClone = this.originalSlides[0].cloneNode(true);
        const lastClone = this.originalSlides[this.realCount - 1].cloneNode(true);
        firstClone.dataset.clone = 'first'; lastClone.dataset.clone = 'last';
        this.track.appendChild(firstClone); this.track.prepend(lastClone);
      }
      bindEvents() {
        this.viewport.addEventListener('pointerdown', this.onDown.bind(this));
        this.viewport.addEventListener('pointermove', this.onMove.bind(this));
        this.viewport.addEventListener('pointerup', this.onUp.bind(this));
        this.viewport.addEventListener('pointercancel', this.onUp.bind(this));
        this.viewport.addEventListener('contextmenu', e => { if (this.isDragging) e.preventDefault(); });
        window.addEventListener('resize', () => this.update(false));
      }
      normalizeIndex() {
        if (this.realCount < 2) return;
        if (this.currentIndex === 0) { this.currentIndex = this.realCount; this.update(false); }
        else if (this.currentIndex === this.realCount + 1) { this.currentIndex = 1; this.update(false); }
      }
      onDown(e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (this.realCount < 2) return;
        this.normalizeIndex(); this.isDragging = true; this.activePointerId = e.pointerId;
        this.startX = e.clientX; this.startY = e.clientY; this.dragX = 0; this.lockedAxis = null;
        this.track.style.transition = 'none'; this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture(e.pointerId);
      }
      onMove(e) {
        if (!this.isDragging || e.pointerId !== this.activePointerId) return;
        const dx = e.clientX - this.startX; const dy = e.clientY - this.startY;
        if (!this.lockedAxis) { if (Math.abs(dx) > 6 || Math.abs(dy) > 6) { this.lockedAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; } }
        if (this.lockedAxis === 'y') { this.cancelDrag(); return; }
        if (this.lockedAxis === 'x') { e.preventDefault(); this.dragX = dx; this.track.style.transform = 'translate3d(' + (this.translate + this.dragX) + 'px, 0, 0)'; }
      }
      onUp(e) {
        if (!this.isDragging) return;
        if (e && e.pointerId !== this.activePointerId) return;
        const wasDraggingX = this.lockedAxis === 'x'; this.endDrag();
        if (!wasDraggingX) return;
        const slideWidth = this.viewport.offsetWidth; const threshold = Math.max(40, slideWidth * 0.15);
        let newIndex = this.currentIndex;
        if (this.dragX < -threshold) newIndex++; else if (this.dragX > threshold) newIndex--;
        this.goTo(newIndex);
      }
      cancelDrag() { this.endDrag(); this.update(false); }
      endDrag() {
        this.isDragging = false; this.viewport.classList.remove('is-dragging');
        if (this.activePointerId !== null) { try { this.viewport.releasePointerCapture(this.activePointerId); } catch (e) {} }
        this.activePointerId = null;
      }
      goTo(index) { this.currentIndex = index; this.update(true); }
      update(animate) {
        const slideWidth = this.viewport.offsetWidth; this.translate = -this.currentIndex * slideWidth;
        this.track.style.transition = animate ? 'transform 0.55s cubic-bezier(0.32, 0.72, 0, 1)' : 'none';
        this.track.style.transform = 'translate3d(' + this.translate + 'px, 0, 0)'; this.updateUI();
        if (animate && this.realCount > 1) {
          const onEnd = () => {
            this.track.removeEventListener('transitionend', onEnd);
            if (this.currentIndex === 0) { this.currentIndex = this.realCount; this.update(false); }
            else if (this.currentIndex === this.realCount + 1) { this.currentIndex = 1; this.update(false); }
          };
          this.track.addEventListener('transitionend', onEnd);
        }
      }
      realIndex() {
        if (this.realCount <= 1) return 0;
        let r = this.currentIndex - 1; if (r < 0) r = this.realCount - 1; if (r >= this.realCount) r = 0; return r;
      }
      updateUI() { const r = this.realIndex(); if (this.counterEl) this.counterEl.textContent = String(r + 1).padStart(2, '0'); if (this.onIndex) this.onIndex(r); }
      goToBySrc(src) {
        if (!src) return; const targetUrl = src.split('?')[0];
        for (let i = 0; i < this.originalSlides.length; i++) {
          const slideSrc = (this.originalSlides[i].dataset.mediaSrc || '').split('?')[0];
          if (slideSrc === targetUrl || slideSrc.includes(targetUrl.split('/').pop())) { this.goTo(this.realCount > 1 ? i + 1 : i); return; }
        }
      }
    }
    const viewport = document.getElementById('tm-viewport-' + sectionId);
    const track = document.getElementById('tm-track-' + sectionId);
    const counterEl = document.getElementById('tm-counter-current-' + sectionId);
    let carousel = null;
    if (viewport && track && track.children.length > 0) { carousel = new TMCarousel({ viewport, track, counterEl }); }
    const idxHandlers = [];
    if (carousel) carousel.onIndex = function(r) { idxHandlers.forEach(h => h(r)); };
    const thumbsWrap = document.getElementById('tm-thumbs-' + sectionId);
    if (thumbsWrap && carousel) {
      const thumbs = Array.from(thumbsWrap.querySelectorAll('.tm-product__thumb'));
      thumbs.forEach(t => t.addEventListener('click', function() {
        const i = parseInt(this.dataset.thumbIndex, 10);
        carousel.goTo(carousel.realCount > 1 ? i + 1 : i);
      }));
      idxHandlers.push(function(r) {
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === r));
        const active = thumbs[r];
        if (active && thumbsWrap.scrollWidth > thumbsWrap.clientWidth) {
          const left = active.offsetLeft - (thumbsWrap.clientWidth - active.offsetWidth) / 2;
          thumbsWrap.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
    }
    const dotsWrap = document.getElementById('tm-dots-' + sectionId);
    if (dotsWrap && carousel) {
      const dots = Array.from(dotsWrap.querySelectorAll('.tm-product__dot'));
      dots.forEach(d => d.addEventListener('click', function() {
        const i = parseInt(this.dataset.dotIndex, 10);
        carousel.goTo(carousel.realCount > 1 ? i + 1 : i);
      }));
      const dPrev = dotsWrap.querySelector('[data-dot-prev]');
      const dNext = dotsWrap.querySelector('[data-dot-next]');
      if (dPrev) dPrev.addEventListener('click', () => { carousel.normalizeIndex(); carousel.goTo(carousel.currentIndex - 1); });
      if (dNext) dNext.addEventListener('click', () => { carousel.normalizeIndex(); carousel.goTo(carousel.currentIndex + 1); });
      const DOT_STEP = 19;
      const DOT_WINDOW = 7;
      function syncDots(r) {
        const total = dots.length;
        let start = 0;
        if (total > DOT_WINDOW) {
          start = Math.min(Math.max(r - Math.floor(DOT_WINDOW / 2), 0), total - DOT_WINDOW);
        }
        dotsWrap.style.setProperty('--tm-dot-shift', (-start * DOT_STEP) + 'px');
        const moreBefore = start > 0;
        const moreAfter = start + DOT_WINDOW < total;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === r);
          d.classList.remove('is-small', 'is-mini');
          if (total <= DOT_WINDOW) return;
          const pos = i - start;
          if (moreBefore && pos === 0) d.classList.add('is-mini');
          else if (moreBefore && pos === 1) d.classList.add('is-small');
          else if (moreAfter && pos === DOT_WINDOW - 1) d.classList.add('is-mini');
          else if (moreAfter && pos === DOT_WINDOW - 2) d.classList.add('is-small');
        });
      }
      idxHandlers.push(syncDots);
    }
    if (viewport && carousel) {
      viewport.querySelectorAll('[data-gnav]').forEach(b => {
        b.addEventListener('pointerdown', e => e.stopPropagation());
        b.addEventListener('click', function(e) {
          e.stopPropagation();
          carousel.normalizeIndex();
          carousel.goTo(carousel.currentIndex + (this.dataset.gnav === 'next' ? 1 : -1));
        });
      });
    }
    if (carousel) carousel.updateUI();
    const zoomEl = document.getElementById('tm-zoom-' + sectionId);
    if (zoomEl && carousel) {
      const zImg = document.getElementById('tm-zoom-img-' + sectionId);
      const zStage = document.getElementById('tm-zoom-stage-' + sectionId);
      const zSrcs = carousel.originalSlides.map(sl => sl.dataset.zoomSrc || sl.dataset.mediaSrc);
      let zi = 0;
      function zPaint() { zImg.src = zSrcs[zi]; zStage.classList.remove('is-zoomed'); zStage.scrollTop = 0; zStage.scrollLeft = 0; }
      function zOpen() { zi = carousel.realIndex(); zPaint(); zoomEl.classList.add('is-open'); zoomEl.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      function zClose() { zoomEl.classList.remove('is-open'); zoomEl.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; carousel.goTo(carousel.realCount > 1 ? zi + 1 : zi); }
      function zStep(d) { zi = (zi + d + zSrcs.length) % zSrcs.length; zPaint(); }
      document.querySelectorAll('[data-tm-open-zoom]').forEach(b => {
        b.addEventListener('pointerdown', e => e.stopPropagation());
        b.addEventListener('click', e => { e.stopPropagation(); zOpen(); });
      });
      zoomEl.querySelectorAll('[data-tm-close-zoom]').forEach(b => b.addEventListener('click', zClose));
      const zPrev = zoomEl.querySelector('[data-tm-zoom-prev]');
      const zNext = zoomEl.querySelector('[data-tm-zoom-next]');
      if (zPrev) zPrev.addEventListener('click', () => zStep(-1));
      if (zNext) zNext.addEventListener('click', () => zStep(1));
      zImg.addEventListener('click', function(e) {
        const on = !zStage.classList.contains('is-zoomed');
        const r = zImg.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        zStage.classList.toggle('is-zoomed', on);
        if (on) {
          zStage.scrollLeft = px * zStage.scrollWidth - zStage.clientWidth / 2;
          zStage.scrollTop = py * zStage.scrollHeight - zStage.clientHeight / 2;
        } else { zStage.scrollTop = 0; zStage.scrollLeft = 0; }
      });
      zStage.addEventListener('click', e => { if (e.target === zStage) zClose(); });
      document.addEventListener('keydown', e => {
        if (!zoomEl.classList.contains('is-open')) return;
        if (e.key === 'Escape') zClose();
        else if (e.key === 'ArrowLeft') zStep(-1);
        else if (e.key === 'ArrowRight') zStep(1);
      });
    }
    let selectedOptions = [];
    const optionGroups = form.querySelectorAll('.tm-product__option');
    optionGroups.forEach((optGroup, idx) => {
      const selectedBtn = optGroup.querySelector('.is-selected') || optGroup.querySelector('.tm-product__color-swatch') || optGroup.querySelector('.tm-product__option-value');
      if (selectedBtn) { selectedBtn.classList.add('is-selected'); selectedOptions[idx] = selectedBtn.dataset.optionValue; }
    });
    if (optionGroups.length === 0 && productData.variants.length) { selectedOptions = productData.variants[0].options.slice(); }
    function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
    function findMatchingVariant() { return productData.variants.find(v => v.options.every((opt, idx) => opt === selectedOptions[idx])); }
    function updateUI() {
      const variant = findMatchingVariant();
      if (!variant) { atcButton.disabled = true; atcText.textContent = L.unavailable; if (stockIndicator) stockIndicator.style.display = 'none'; return; }
      variantIdInput.value = variant.id;
      let html = '<span class="tm-product__price-current">' + formatMoney(variant.price) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<span class="tm-product__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
        if (priceContainer.dataset.saveOn === '1') {
          const escHtml = function (x) { return String(x).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); };
          const diff = variant.compare_at_price - variant.price;
          const saveValue = priceContainer.dataset.saveMode === 'amount'
            ? formatMoney(diff)
            : Math.floor(diff * 100 / variant.compare_at_price) + '%';
          html += '<span class="tm-product__save">' + escHtml(priceContainer.dataset.saveLabel || 'Save') + ' ' + saveValue + '</span>';
        }
      }
      priceContainer.innerHTML = html;
      if (variant.available) { atcButton.disabled = false; atcText.textContent = L.label; if (stockIndicator) stockIndicator.style.display = ''; }
      else { atcButton.disabled = true; atcText.textContent = L.soldout; if (stockIndicator) stockIndicator.style.display = 'none'; }
      form.querySelectorAll('[data-selected-for]').forEach(el => { const idx = parseInt(el.dataset.selectedFor); el.textContent = selectedOptions[idx] || ''; });
      const url = new URL(window.location); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      if (variant.featured_image && carousel) carousel.goToBySrc(variant.featured_image.src);
    }
    form.querySelectorAll('.tm-product__color-swatch, .tm-product__option-value').forEach(btn => {
      btn.addEventListener('click', function() {
        const idx = parseInt(this.dataset.optionIndex);
        const groupSelector = this.classList.contains('tm-product__color-swatch') ? '.tm-product__color-swatch' : '.tm-product__option-value';
        this.parentElement.querySelectorAll(groupSelector).forEach(s => s.classList.remove('is-selected'));
        this.classList.add('is-selected'); selectedOptions[idx] = this.dataset.optionValue; updateUI();
      });
    });
    const sizeGuide = document.getElementById('tm-size-guide-' + sectionId);
    if (sizeGuide) {
      const openTriggers = document.querySelectorAll('[data-tm-open-size-guide]');
      const closeTriggers = sizeGuide.querySelectorAll('[data-tm-close-size-guide]');
      const tabs = sizeGuide.querySelectorAll('.tm-size-guide__tab');
      const panels = sizeGuide.querySelectorAll('.tm-size-guide__panel');
      function openSizeGuide() { sizeGuide.classList.add('is-open'); sizeGuide.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      function closeSizeGuide() { sizeGuide.classList.remove('is-open'); sizeGuide.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
      openTriggers.forEach(b => b.addEventListener('click', openSizeGuide));
      sizeGuide.querySelectorAll('[data-tm-units]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeGuide.classList.toggle('is-inches', btn.dataset.tmUnits === 'in');
          sizeGuide.querySelectorAll('[data-tm-units]').forEach(function (other) {
            const on = other === btn;
            other.classList.toggle('is-active', on);
            other.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
      });
      closeTriggers.forEach(b => b.addEventListener('click', closeSizeGuide));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sizeGuide.classList.contains('is-open')) closeSizeGuide(); });
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const name = tab.dataset.tab;
          tabs.forEach(t => t.classList.toggle('is-active', t === tab));
          panels.forEach(pnl => pnl.classList.toggle('is-active', pnl.dataset.panel === name));
        });
      });
    }
    async function addToCart(variantId, qty) {
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', qty);
      const res = await fetch('/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) {
        let msg = L.errortext;
        try { msg = (await res.json()).description || msg; } catch (e) {}
        throw new Error(msg);
      }
      if (window.tmCart && typeof window.tmCart.added === 'function') {
        try { await window.tmCart.added(); return; } catch (e) {}
      }
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      window.location.href = '/cart';
    }
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      if (atcButton.disabled) return;
      const original = atcText.textContent;
      atcButton.disabled = true;
      atcText.textContent = L.adding;
      try {
        const qtyInput = form.querySelector('[name="quantity"]');
        const qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
        await addToCart(variantIdInput.value, qty);
        atcText.textContent = L.added;
        setTimeout(() => { atcText.textContent = original; atcButton.disabled = false; }, 1500);
      } catch (err) {
        console.error('[TM ATC] Failed:', err);
        atcText.textContent = (err && err.message && err.message.length <= 24) ? err.message : L.errortext;
        setTimeout(() => { atcText.textContent = original; atcButton.disabled = false; }, 2500);
      }
    });
    updateUI();
  }

  function boot(root) {
    if (!root || root.dataset.tmProductBound === '1') return;
    root.dataset.tmProductBound = '1';
    initSection(root.dataset.tmProductSection);
  }

  function bootAll(scope) {
    const el = scope || document;
    if (el.dataset && el.dataset.tmProductSection) boot(el);
    el.querySelectorAll('[data-tm-product-section]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { bootAll(); });
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', function(e) { bootAll(e.target); });
})();
